import React from 'react'

import { Icon } from '@app/components/util'
import { LntIconButton } from '@app/components/base'

import { ICON_NAME } from '@app/constants/icon'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import variables from '@app/theme/variables'

import type { TableGroupButtonProps } from './types'

export const TableGroupButton: React.FC<TableGroupButtonProps> = ({ active, ...iconButtonProps }) => {
  const textColor = active ? variables.brandBlue : undefined

  return (
    <LntIconButton
      { ...iconButtonProps }
      textColor={ textColor }
      type={ BUTTON_TYPE.text }
      size={ SIZE.small }
      icon={ <Icon name={ ICON_NAME.group } /> }
    />
  )
}
